import "./historyChart.css";

const TimeFrameSelect = ({
    buttons,
    selected,
    onBtnClick,
}: {
    buttons: { name: string; value: number }[];
    selected?: number;
    onBtnClick: (idx: number) => void;
}): JSX.Element => {
    const buttonElems: JSX.Element[] = [];
    for (const btn of buttons) {
        const cssClasses: string[] = ["button", "timeFrameSelectBtn"];
        if (typeof selected !== "undefined" && btn.value == selected) cssClasses.push("selected");
        buttonElems.push(
            <button key={btn.name} className={cssClasses.join(" ")} onClick={() => onBtnClick(btn.value)}>
                {btn.name}
            </button>
        );
    }

    return <div className="timeFrameSelect">{buttonElems}</div>;
};

export default TimeFrameSelect;
